module.exports = __webpack_public_path__ + "img/take-photo.5664bf5e.svg";